import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';

@Component({
  selector: 'app-route-business-change-log',
  templateUrl: './route-business-change-log.component.html',
  styleUrls: ['./route-business-change-log.component.scss']
})
export class RouteBusinessChangeLogComponent implements OnInit {

  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  route_business_change_log_data: any = [];
  title: any;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.is_data_available = false;
    this.httpService.serveRouteBusinessChangeLog().subscribe((data) => {
      console.log(data);
      this.route_business_change_log_data = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }


  ngOnInit() {
  }

}
